<template>
  <el-select v-bind="$attrs" v-model="selectedData" multiple @remove-tag="handleRemoveTag">
    <el-option
      v-for="(item, index) in options"
      :key="index"
      :label="item[labelKey]"
      :value="item[valueKey]"
      @click.native="handleOptionClick(item)"
    >
    </el-option>
  </el-select>
</template>

<script>
/**
 * 1.组件用途：
 *  多选下拉框组件
 * 2.组件回调：
 *  onSelectedChange 组件事件回调-用户操作引发已选项变化，返回值：已选项的value值数组 已选项的数据数组
 * 3.外部调用方法：
 *  setSelectedData 设置已选数据（一般用于初始化已选项数据），参数：已选项的value值数组
 */
export default {
  props: {
    // 选项数据
    options: {
      type: Array,
      default: () => []
    },
    // 选项数据的label字段名-用于设置选项显示的文本
    labelKey: {
      type: String,
      default: 'name'
    },
    // 选项数据的value字段名-用于设置选项的value值
    valueKey: {
      type: String,
      default: 'id'
    },
    // 全选项的value值-用于标识全选项
    selectAllValue: {
      type: Number || String,
      default: -1
    }
  },
  data() {
    return {
      selectedData: [] // 已选的数据
    }
  },
  computed: {
    // 是否有全选项
    optionHasSelectAll() {
      return this.options.some((item) => item[this.valueKey] === this.selectAllValue)
    }
  },
  methods: {
    reset(){
      this.selectedData = []
    },
    // 设置已选择的数据
    setSelectedData(data) {
      this.selectedData = data
      if (this.isSelectedAll()) {
        this.selectedData = Array.from(new Set([this.selectAllValue, ...this.selectedData]))
      }
    },
    // 发送消息给父组件
    sendMsg() {
      // 返回数据中过滤掉全选项
      const keys = this.selectedData.filter((item) => item !== this.selectAllValue)
      const options = this.options.filter((item) => keys.includes(item[this.valueKey]))
      this.$emit('onSelectedChange', keys, options)
    },
    // 选项是否被全部选中了（不包含全选项）
    isSelectedAll() {
      if (!this.optionHasSelectAll) return false // 无全选项时，不可能全选
      let isSeletedAll = true
      if (this.options.length <= 0) {
        isSeletedAll = false
      }
      this.options.forEach((ele) => {
        if (!this.selectedData.includes(ele.id) && ele.id != this.selectAllValue) {
          isSeletedAll = false
        }
      })
      return isSeletedAll
    },
    // 移除标签回调
    handleRemoveTag(key) {
      if (key === this.selectAllValue) {
        this.selectedData = []
      } else {
        this.selectedData = this.selectedData.filter((item) => item !== this.selectAllValue)
      }
      this.sendMsg()
    },
    // 点击标签回调
    handleOptionClick(option) {
      // --- 点击全部卡种标签 ---
      if (option[this.valueKey] === this.selectAllValue) {
        // 勾选全选-全部选中
        if (this.selectedData.includes(option[this.valueKey])) {
          this.selectedData = Array.from(
            new Set([...this.selectedData, ...this.options.map((item) => item[this.valueKey])])
          ).sort((a, b) => a - b)
          this.sendMsg()
          return
        }
        // -- 取消全选 --
        // 目前为非全选状态-全部选中
        if (!this.isSelectedAll()) {
          this.selectedData = Array.from(
            new Set([...this.selectedData, ...this.options.map((item) => item[this.valueKey])])
          ).sort((a, b) => a - b)
        } else {
          // 目前为全选状态-全部清空
          this.selectedData = []
        }
        this.sendMsg()
        return
      }
      // --- 点击其他标签(非全部卡种) ---
      // 未全部选中时-移除全部卡种标签
      if (!this.selectedData.includes(option[this.valueKey])) {
        this.selectedData = this.selectedData.filter((ele) => ele !== this.selectAllValue).sort((a, b) => a - b)
        this.sendMsg()
        return
      }
      // 全部选中时-加入全部卡种标签
      if (this.isSelectedAll()) {
        this.selectedData = Array.from(new Set([...this.selectedData, ...[this.selectAllValue]])).sort((a, b) => a - b)
        this.sendMsg()
        return
      }
      // 其他情况-排序
      this.selectedData = this.selectedData.sort((a, b) => a - b)
      this.sendMsg()
    }
  }
}
</script>

<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// src/components/multipeSelect.vue